import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-feed-feature',
  templateUrl: './feed-feature.component.html',
  styleUrls: ['./feed-feature.component.css']
})
export class FeedFeatureComponent {  
  id: any;
  constructor(private route: ActivatedRoute) {
    this.id = null;
  }
  ngOnInit(): void {
    this.id = Number(this.route.snapshot.paramMap.get('id'));
  }
}
